import React from 'react';
import { Link } from 'react-router-dom';
import {
    FaInstagram, FaWhatsapp, FaShieldAlt,
    FaTruck, FaCreditCard, FaMapMarkerAlt, FaEnvelope
} from 'react-icons/fa';
import styles from './Footer.module.css';
import infiniteLogo from './image/infinitepay.png';
import melhorEnvioLogo from './image/melhorenvio.png';

function Footer() {
    const handleWhatsAppClick = () => {
        window.open('https://wa.me/5547999448042', '_blank', 'noopener,noreferrer');
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.accentBar}></div>

            <div className={styles.container}>
                <div className={styles.brandSection}>
                    <h2 className={styles.brandName}>JUNGLE <span>ARTIGOS MILITARES.</span></h2>
                    <p className={styles.description}>
                        Equipamentos de alta performance forjados para missões reais.
                        Qualidade absoluta em cada detalhe.
                    </p>
                    <div className={styles.socialIcons}>
                        <a href="https://instagram.com/jungleartigosmilitares" target="_blank" rel="noreferrer" aria-label="Instagram">
                            <FaInstagram />
                        </a>
                        <button className={styles.socialButton} onClick={handleWhatsAppClick} aria-label="WhatsApp">
                            <FaWhatsapp />
                        </button>
                    </div>
                </div>

                <div className={styles.linksSection}>
                    <span className={styles.label}>NAVEGAÇÃO</span>
                    <ul className={styles.linkList}>
                        <li><Link to="/">Início</Link></li>
                        <li><Link to="/products">Equipamentos</Link></li>
                        <li><Link to="/about">Nossa História</Link></li>
                        <li><Link to="/support">Suporte</Link></li>
                    </ul>
                </div>

                <div className={styles.contactSection}>
                    <span className={styles.label}>ATENDIMENTO</span>
                    <div className={styles.contactInfo}>
                        <p><FaMapMarkerAlt /> Blumenau, SC - Brasil</p>
                        <p><FaEnvelope /> jungleartigosmilitares@gmail.com</p>
                        <p className={styles.whatsapp}><FaWhatsapp /> (47) 47 99944-8042</p>
                    </div>
                </div>
            </div>

            <div className={styles.trustBar}>
                <div className={styles.trustContainer}>
                    <div className={styles.trustItem}>
                        <FaCreditCard />
                        <div><span className={styles.trustTitle}>PAGAMENTO</span><p>Até 12x no cartão</p></div>
                    </div>
                    <div className={styles.trustItem}>
                        <FaTruck />
                        <div><span className={styles.trustTitle}>ENVIO</span><p>Todo o Brasil</p></div>
                    </div>
                    <div className={styles.trustItem}>
                        <FaShieldAlt />
                        <div><span className={styles.trustTitle}>SEGURANÇA</span><p>SSL Protegido</p></div>
                    </div>
                </div>
            </div>

            <div className={styles.partnersAndPayments}>
                <div className={styles.methodsInner}>
                    <div className={styles.partnersRow}>
                        <div className={styles.partnerGroup}>
                            <span className={styles.secureTag}>PAGAMENTO VIA</span>
                            <img src={infiniteLogo} className={styles.infiniteLogo} alt="InfinitePay" />
                        </div>
                        <div className={styles.partnerGroup}>
                            <span className={styles.secureTag}>LOGÍSTICA</span>
                            <img src={melhorEnvioLogo} className={styles.partnerLogo} alt="Melhor Envio" />
                        </div>
                    </div>

                    <div className={styles.cardGrid}>
                        {/* VISA - CORRIGIDO */}
                        <svg width="45" height="28" viewBox="0 0 35 22">
                            <rect width="35" height="22" rx="2" fill="#1A1F71" />
                            <text x="17.5" y="15" fontSize="10" fontWeight="bold" textAnchor="middle" fill="#FFF" style={{ fontFamily: 'Verdana, sans-serif', italic: 'italic' }}>VISA</text>
                        </svg>

                        {/* MASTERCARD */}
                        <svg width="45" height="28" viewBox="0 0 35 22">
                            <rect width="35" height="22" rx="2" fill="#222" />
                            <circle cx="14.5" cy="11" r="7" fill="#EB001B" />
                            <circle cx="20.5" cy="11" r="7" fill="#F79E1B" fillOpacity="0.8" />
                        </svg>

                        {/* ELO - CORRIGIDO */}
                        <svg width="45" height="28" viewBox="0 0 35 22">
                            <rect width="35" height="22" rx="2" fill="#000" />
                            <text x="17.5" y="14.5" fontSize="9" fontWeight="bold" textAnchor="middle" fill="#FFF" style={{ fontFamily: 'Arial, sans-serif' }}>ELO</text>
                        </svg>

                        {/* PIX */}
                        <svg width="45" height="28" viewBox="0 0 35 22">
                            <rect width="35" height="22" rx="2" fill="#32BCAD" />
                            <path d="M17.5 6l-4 4 4 4 4-4-4-4zm-5.5 4l1.5 1.5L12 13l-1.5-1.5L12 10zm11 0l-1.5 1.5 1.5 1.5 1.5-1.5L23 10z" fill="#FFF" />
                        </svg>
                    </div>
                </div>
            </div>

            <div className={styles.bottom}>
                <div className={styles.bottomContainer}>
                    <span>© 2026 JUNGLE ARTIGOS MILITARES // BRASIL</span>
                    <div className={styles.legalLinks}>
                        <Link to="/privacidade">PRIVACIDADE</Link>
                        <Link to="/termos">TERMOS</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;